const GTM = require('../datalayer');

let savedGlobalObj = {};

const setConsentTrackingData = (dlObj) => {
    // eslint-disable-next-line import/no-unresolved, global-require
    const utils = require('onestic-base/utils');
    const dlOBJ = dlObj;
    const adStorage = utils.getCookie('dwmarketing_')
        ? 'granted' : 'denied';
    const analyticsStorage = utils.getCookie('dwmarketing_')
        ? 'granted' : 'denied';
    const functionalityStorage = utils.getCookie('dwpersonalization_')
        ? 'granted' : 'denied';

    // Only required cookies will be enabled on the first view without accept or denied cookies
    if (utils.getCookie('consent') !== '') {
        dlOBJ.required = 'granted';
        dlOBJ.ad_storage = adStorage;
        dlOBJ.analytics_storage = analyticsStorage;
        dlOBJ.functionality_storage = functionalityStorage;
        dlOBJ.ad_user_data = adStorage;
        dlOBJ.ad_personalization = adStorage;
        dlOBJ.personalization_storage = functionalityStorage;
    } else {
        dlOBJ.required = 'granted';
        dlOBJ.ad_storage = 'denied';
        dlOBJ.analytics_storage = 'denied';
        dlOBJ.functionality_storage = 'denied';
        dlOBJ.ad_user_data = 'denied';
        dlOBJ.ad_personalization = 'denied';
        dlOBJ.personalization_storage = 'denied';
    }

    return dlOBJ;
};

const initConsent = () => {
    const result = {
        event: 'init_consent',
    };

    return setConsentTrackingData(result);
};

const getGeneralData = () => {
    const pageType = $('#datalayerKindList').data('list');
    const $userLoginStatus = $('#user_login_status');
    const $userLoginId = $('#user_login_id');
    const $pageCode = $('#page-code');

    const userLoginStatus = $userLoginStatus.length
        ? $userLoginStatus.attr('value').split('_')[0] : '';
    const userLoginId = $userLoginId.length
        ? $userLoginId.attr('value') : '';
    const pageCode = $pageCode.length
        ? $pageCode.attr('value') : '';

    let result = {
        event: 'gtm.datalayer',
        page_type: pageType !== '' ? pageType : '',
        userLoginStatus,
        userLoginId,
        pageCode,
    };

    if (pageType === 'category') {
        result.page_catN1 = $('#datalayerKindListName').data('list');
    }

    result = setConsentTrackingData(result);

    savedGlobalObj = result;

    return result;
};

const collectConsentTrackingInfo = () => {
    $('body').on('click', '.consent_buttons .affirm', () => {
        const consentBar = $('#consent-tracking');
        const personalization = consentBar
            .find('#cookie-personalization')
            .is(':checked')
            ? 'granted'
            : 'denied';
        const consent = consentBar
            .find('#cookie-analisys')
            .is(':checked')
            ? 'granted'
            : 'denied';
        const consentData = {};

        if (savedGlobalObj.ad_storage !== personalization) {
            consentData.functionality_storage = personalization;
        }

        if (savedGlobalObj.analytics_storage !== consent) {
            consentData.analytics_storage = consent;
            consentData.ad_storage = consent;
        }

        if (!('functionality_storage' in consentData) && !('analytics_storage' in consentData)) {
            consentData.event = 'update_consent';
            consentData.analytics_storage = 'denied';
            consentData.ad_storage = 'denied';
            consentData.functionality_storage = 'denied';
            consentData.ad_user_data = 'denied';
            consentData.ad_personalization = 'denied';
            consentData.personalization_storage = 'denied';
        } else {
            consentData.event = 'update_consent';
            consentData.analytics_storage = consent;
            consentData.ad_storage = consent;
            consentData.functionality_storage = personalization;
            consentData.ad_user_data = consent;
            consentData.ad_personalization = consent;
            consentData.personalization_storage = personalization;
        }

        GTM.triggerSendDataLayer(consentData);
    });

    $('body').on('click', '.consent_buttons .decline', () => {
        const consentData = {};

        consentData.event = 'update_consent';
        consentData.analytics_storage = 'denied';
        consentData.ad_storage = 'denied';
        consentData.functionality_storage = 'denied';
        consentData.ad_user_data = 'denied';
        consentData.ad_personalization = 'denied';
        consentData.personalization_storage = 'denied';

        GTM.triggerSendDataLayer(consentData);
    });
};

const eventShowMinicart = () => {
    $('body').on('seo:showMinicart', () => {
        const $productsInCart = $('.minicart-container').find('[id^="delete-"]');

        if ($productsInCart.length) {
            const productsInCart = $productsInCart.map((indx, elem) => JSON.parse($(elem).attr('data-info'))).get();

            GTM.trackShowCart(productsInCart);
        }
    });
};

const eventShowCartPage = () => {
    const cartPage = $('.cart.cart-page');

    if (cartPage.length) {
        const $inputData = $('.cart.cart-page').parent().find('#datalayerProducts');
        const $productsInCart = $inputData.length ? JSON.parse($inputData.val()) : 0;

        if ($productsInCart.product.length) {
            GTM.trackShowCart($productsInCart.product);
        }
    }
};

const eventDeleteProductFromCart = () => {
    $('body').on('seo:removeProductCart', (event, deleteInfo) => {
        GTM.trackDeleteProductToCart(deleteInfo);
    });
};

const handleCartItemQuantity = () => {
    const docBody = $(document.body);
    const moreClass = '.more-btn';
    const lessClass = '.less-btn';

    docBody.off(moreClass).on('click', moreClass, (e) => {
        const productId = $(e.currentTarget).parent().find('.quantity').data('pid');
        const datalayerInfo = $(`#delete-${productId}`).data('info');

        GTM.trackAddProductToCart(datalayerInfo);
    });

    docBody.off(lessClass).on('click', lessClass, (e) => {
        const productId = $(e.currentTarget).parent().find('.quantity').data('pid');
        const datalayerInfo = $(`#delete-${productId}`).data('info');

        GTM.trackDeleteProductToCart(datalayerInfo);
    });
};

module.exports = {
    sentInitialGlobalData() {
        GTM.triggerSendDataLayer(getGeneralData());
    },
    sentInitConsent() {
        GTM.triggerSendDataLayer(initConsent());
    },
    collectConsentTrackingInfo,
    eventShowMinicart,
    eventShowCartPage,
    eventDeleteProductFromCart,
    handleCartItemQuantity,
};
